<div class="app-container">
  <page-header [icon]="'fa-file-check'" [title]="'inventoryExports'">
    <ng-container class="header-button">
      <modal-print-export
        [exportType]="'inventory-exports'"
        (resultExport)="createExportInventory($event)"
        [dataCyAttribute]="'add-inventory'"
      ></modal-print-export>
    </ng-container>
  </page-header>

  <section class="content">
    <div class="container-fluid ps-0 pe-0">
      <app-base-listing
        [listName]="'printInventoryExports'"
        [query]="queryInventoryExports"
        [columns]="listingColumns"
        [selectedColumns]="listingColumns"
        [sortProp]="sortProp"
        [sortDir]="sortDir"
        (callAction)="callAction($event)"
      ></app-base-listing>
    </div>
  </section>
</div>
